module.exports = __webpack_public_path__ + "static/media/noSignal.943faae3.svg";